import styled, { css } from 'styled-components';
import { forceBreakTextCss } from '../styles';
export const TitleSection = styled.div ``;
export const Cards = styled.div `
    text-align: left;

    > a > div {
        margin-bottom: 16px;
    }

    > a:last-child > div {
        margin-bottom: 0;
    }
`;
export const Card = styled.div `
    ${forceBreakTextCss};
    overflow: hidden;
    text-overflow: ellipsis;

    background: ${(props) => props.theme.cardColor};
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 8px;

    cursor: pointer;
    display: flex;
    align-items: center;

    h6 {
        color: ${(props) => props.theme.cardText};
        margin: 0;
    }
    > div:first-child {
        flex: 1;
        margin-left: 8px;
        margin-right: 8px;
    }
`;
export const ThumbnailContainer = styled.div `
    width: 68px;
    height: 68px;

    font-size: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${(props) => props.$present &&
    props.$type === 'EMOJI' &&
    css `
            background-color: #ffffff;
            border-radius: 4px;
        `};

    > img {
        width: 68px;
        height: 68px;
        object-fit: cover;
        border-radius: 4px;
    }
`;
